import React from 'react'
import { type AIClient, type AIExecuteClient, type MediaClient } from '@zocks-communications/client-sdk-js'

export interface APIClientRegistry {
  mediaClient: MediaClient
  aiClient: AIClient
  aiExecuteClient: AIExecuteClient
  trackingEnabled: boolean
  trackingApiBaseUrl: string
}

export const APIClientContext = React.createContext<APIClientRegistry | null>(null)

export const useAPIClient = () => {
  const ctx = React.useContext(APIClientContext)
  if (!ctx) {
    throw new Error('Unable to initialize APIClientContext')
  }
  return ctx
}
